import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { myroutes } from "../../routes/webroute";
import AuthService from "../../services/AuthService";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import { checkAuthenticate, resetAuthData } from "../../app/providers/authSlice";
import { logoutRequest } from "../auth/logout";
//import { authCheck } from "../../services/http";

export default function SideBar() {

    const location = useLocation();
    const url = location.pathname;
    const navigate = useNavigate()
 
    const auth = useSelector(state => state.auth)
    const dispatch = useDispatch()

    dispatch(checkAuthenticate)

    // se déconnecter
	const handleLogout = () => {  
		logoutRequest(auth.token);
		dispatch(resetAuthData());
	}

    const activeStorage = async () => {
        await AuthService.activeStorage().then(response => {
            if (response.data.resultat) {
                Swal.fire({
                    icon: "success",
                    text: response.data.resultat,
                    toast: true,
                    position: 'top-right',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    background: "green",
                    color: "white",
                    iconColor: "white"
                })
            } else {
                Swal.fire({
                    icon: "error",
                    text: response.data.error,
                    toast: true,
                    position: 'top-right',
                    showConfirmButton: false,
                    timer: 3500,
                    timerProgressBar: true,
                    background: "red",
                    color: "white",
                    iconColor: "white"
                })
            }
        }).catch(error => {
            console.log(error.message)
        });
    }

    const clearCache = async () => {
        await AuthService.clearCache().then(response => {
            if (response.data.resultat) {
                Swal.fire({
                    icon: "success",
                    text: response.data.resultat,
                    toast: true,
                    position: 'top-right',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    background: "green",
                    color: "white",
                    iconColor: "white"
                })
            } else {
                Swal.fire({
                    icon: "error",
                    text: response.data.error,
                    toast: true,
                    position: 'top-right',
                    showConfirmButton: false,
                    timer: 3500,
                    timerProgressBar: true,
                    background: "red",
                    color: "white",
                    iconColor: "white"
                })
            }

            //console.log(response.data)
        }).catch(error => {
            console.log(error.message)
        });
    }


    useEffect(() => {
        
    }, [navigate]);


    return (
        <React.Fragment>

            <div id="app-sidepanel" className="app-sidepanel">
                <div id="sidepanel-drop" className="sidepanel-drop"></div>
                <div className="sidepanel-inner d-flex flex-column">
                    <Link to={myroutes.homepage} id="sidepanel-close" className="sidepanel-close d-xl-none">&times;</Link>
                    <div className="app-branding">
                        <Link to={myroutes.homepage} className="app-logo"><img className="logo-icon me-2" src="/logo-digiweb-l100.png"
                            alt="logo" /><span className="logo-textx">DGBOOK</span></Link>

                    </div>{/*//app-branding*/}

                    <nav id="app-nav-main" className="app-nav app-nav-main flex-grow-1">
                        <ul className="app-menu list-unstyled accordion" id="menu-accordion">
                            <li className="nav-item">
                                {/*MENU */}
                                <NavLink to={myroutes.dashboard} className="nav-link">
                                    <span className="nav-icon">
                                        <i className="fas fa-home text-secondary"></i>
                                    </span>
                                    <span className="nav-link-text">Dashboard</span>
                                </NavLink>{/*//nav-link*/}
                            </li>

                            {auth.roles?.includes("ADMIN") ||auth.roles?.includes("AUTEUR") ?
                                <li className="nav-item has-submenu">
                                    {/* sidebar menu auteur */}
                                    <Link className="nav-link submenu-toggle" data-bs-toggle="collapse"
                                        data-bs-target="#submenu-1" aria-expanded="false" aria-controls="submenu-1">
                                        <span className="nav-icon">
                                            {/* */}
                                            <i className="fas fa-file text-secondary"></i>
                                        </span>
                                        <span className="nav-link-text">Publications</span>
                                        <span className="submenu-arrow">
                                            <svg width="1em" height="1em" viewBox="0 0 16 16" className="bi bi-chevron-down"
                                                fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                <path fillRule="evenodd"
                                                    d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" />
                                            </svg>
                                        </span>{/*//submenu-arrow*/}
                                    </Link>

                                    <div id="submenu-1" className="collapse submenu submenu-1" data-bs-parent="#menu-accordion">
                                        <ul className="submenu-list list-unstyled">
                                            <li className="submenu-item"><Link to={myroutes.publications_create} className={url === myroutes.publications_create ? 'submenu-link active' : 'submenu-link'}
                                            >Nouvelle</Link></li>
                                            <li className="submenu-item"><Link to={myroutes.publications_index} className={url === myroutes.publications_index ? 'submenu-link active' : 'submenu-link'}>Liste</Link>
                                            </li>
                                        </ul>
                                    </div>
                                </li> : false}

                            {auth.roles?.includes("ADMIN") || auth.roles?.includes("ADMIN") &&
                                <React.Fragment>
                                <li className="nav-item has-submenu">
                                    {/* */}
                                    <Link className="nav-link submenu-toggle" data-bs-toggle="collapse"
                                        data-bs-target="#submenu-3" aria-expanded="false" aria-controls="submenu-3">
                                        <span className="nav-icon">
                                            <i className="fas fa-shopping-cart text-secondary"></i>
                                        </span>
                                        <span className="nav-link-text">Ventes</span>
                                        <span className="submenu-arrow">
                                            <svg width="1em" height="1em" viewBox="0 0 16 16" className="bi bi-chevron-down"
                                                fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                <path fillRule="evenodd"
                                                    d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" />
                                            </svg>
                                        </span>
                                        {/*//submenu-arrow*/}
                                    </Link>

                                    <div id="submenu-3" className="collapse submenu submenu-3" data-bs-parent="#menu-accordion">
                                        <ul className="submenu-list list-unstyled">
                                            <li className="submenu-item"><Link to={myroutes.ventes} className={url === myroutes.ventes ? 'submenu-link active' : 'submenu-link'} >Quotidiennes</Link>
                                            </li>
                                            <li className="submenu-item"><Link to={myroutes.abonnements} className={url === myroutes.abonnements ? 'submenu-link active' : 'submenu-link'} >Abonnements</Link>
                                            </li>
                                        </ul>
                                    </div>
                                </li> 
                                <li className="nav-item">
                                    {/* */}
                                    <Link className="nav-link" >
                                        <span className="nav-icon">
                                            <svg width="1em" height="1em" viewBox="0 0 16 16" className="bi bi-folder"
                                                fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M9.828 4a3 3 0 0 1-2.12-.879l-.83-.828A1 1 0 0 0 6.173 2H2.5a1 1 0 0 0-1 .981L1.546 4h-1L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3v1z" />
                                                <path fillRule="evenodd"
                                                    d="M13.81 4H2.19a1 1 0 0 0-.996 1.09l.637 7a1 1 0 0 0 .995.91h10.348a1 1 0 0 0 .995-.91l.637-7A1 1 0 0 0 13.81 4zM2.19 3A2 2 0 0 0 .198 5.181l.637 7A2 2 0 0 0 2.826 14h10.348a2 2 0 0 0 1.991-1.819l.637-7A2 2 0 0 0 13.81 3H2.19z" />
                                            </svg>
                                        </span>
                                        <span className="nav-link-text">Statistiques</span>
                                    </Link>
                                </li>
                                </React.Fragment>
                                }
                            {/*//nav-item*/}

                            { auth.roles?.includes("ADMIN") &&
                                <React.Fragment>
                                <li className="nav-item has-submenu">
                                    {/* */}
                                    <Link className="nav-link submenu-toggle" data-bs-toggle="collapse"
                                        data-bs-target="#submenu-5" aria-expanded="false" aria-controls="submenu-5">
                                        <span className="nav-icon">
                                            <i className="fab fa-resolving text-secondary"></i>
                                        </span>
                                        <span className="nav-link-text">Reversements</span>
                                        <span className="submenu-arrow">
                                            <svg width="1em" height="1em" viewBox="0 0 16 16" className="bi bi-chevron-down"
                                                fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                <path fillRule="evenodd"
                                                    d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" />
                                            </svg>
                                        </span>{/*//submenu-arrow*/}
                                    </Link>

                                    <div id="submenu-5" className="collapse submenu submenu-5" data-bs-parent="#menu-accordion">
                                        <ul className="submenu-list list-unstyled">

                                            <li className="submenu-item"><Link to={myroutes.reversements_page} className={url === myroutes.reversements_page ? 'submenu-link active' : 'submenu-link'} >Operation</Link></li>
                                            <li className="submenu-item"><a className="submenu-link" href="#">Liste reversements</a></li>

                                        </ul>
                                    </div>
                                </li> 
                                <li className="nav-item has-submenu">
                                    {/* */}
                                    <Link className="nav-link submenu-toggle" data-bs-toggle="collapse"
                                        data-bs-target="#submenu-6" aria-expanded="false" aria-controls="submenu-6">
                                        <span className="nav-icon">
                                            <i className="fas fa-id-card-alt text-secondary"></i>
                                        </span>
                                        <span className="nav-link-text">Contact</span>
                                        <span className="submenu-arrow">
                                            <svg width="1em" height="1em" viewBox="0 0 16 16" className="bi bi-chevron-down"
                                                fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                <path fillRule="evenodd"
                                                    d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" />
                                            </svg>
                                        </span>{/*//submenu-arrow*/}
                                    </Link>
                                    {/*//nav-link*/}
                                    <div id="submenu-6" className="collapse submenu submenu-6" data-bs-parent="#menu-accordion">
                                        <ul className="submenu-list list-unstyled">
                                            <li className="submenu-item"><Link to={myroutes.contact_liste} className={url === myroutes.contact_liste ? 'submenu-link active' : 'submenu-link'} >Liste</Link></li>
                                        </ul>
                                    </div>
                                </li> 
                                <li className="nav-item has-submenu">
                                    {/*GESTION */}
                                    <a className="nav-link submenu-toggle" href="#" data-bs-toggle="collapse"
                                        data-bs-target="#submenu-2" aria-expanded="false" aria-controls="submenu-2">
                                        <span className="nav-icon">
                                            <i className="fas fa-cogs text-secondary"></i>
                                        </span>
                                        <span className="nav-link-text">Gestion</span>
                                        <span className="submenu-arrow">
                                            <svg width="1em" height="1em" viewBox="0 0 16 16" className="bi bi-chevron-down"
                                                fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                <path fillRule="evenodd"
                                                    d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" />
                                            </svg>
                                        </span>{/*//submenu-arrow*/}
                                    </a>

                                    <div id="submenu-2" className="collapse submenu submenu-2" data-bs-parent="#menu-accordion">
                                        <ul className="submenu-list list-unstyled">
                                            <li className="submenu-item"><Link to={myroutes.auteurs_index} className={url === myroutes.auteurs_index ? 'submenu-link active' : 'submenu-link'} >Auteurs</Link></li>
                                            <li className="submenu-item"><Link to={myroutes.editeurs_index} className={url === myroutes.editeurs_index ? 'submenu-link active' : 'submenu-link'} >Editeurs</Link></li>
                                            <li className="submenu-item"><Link to={myroutes.periodiques_index} className={url === myroutes.periodiques_index ? 'submenu-link active' : 'submenu-link'} >Périodiques</Link></li>
                                            <li className="submenu-item"><Link to={myroutes.tarifications_index} className={url === myroutes.tarifications_index ? 'submenu-link active' : 'submenu-link'} >Tarifications</Link></li>
                                            <li className="submenu-item"><Link to={myroutes.modepaiements_index} className={url === myroutes.modepaiements_index ? 'submenu-link active' : 'submenu-link'} >Mode de paiements</Link></li>
                                            <li className="submenu-item"><Link to={myroutes.motscles_index} className={url === myroutes.motscles_index ? 'submenu-link active' : 'submenu-link'} >Mots cles</Link></li>
                                            <li className="submenu-item"><Link to={myroutes.typespublications_index} className={url === myroutes.typespublications_index ? 'submenu-link active' : 'submenu-link'} >Types de publications</Link></li>

                                        </ul>
                                    </div>
                                </li>  
                                <li className="nav-item has-submenu">
                                    {/*Administration */}
                                    <a className="nav-link submenu-toggle" href="#" data-bs-toggle="collapse"
                                        data-bs-target="#submenu-4" aria-expanded="false" aria-controls="submenu-4">
                                        <span className="nav-icon">
                                            <i className="fas fa-lock text-secondary"></i>
                                        </span>
                                        <span className="nav-link-text">Administration</span>
                                        <span className="submenu-arrow">
                                            <svg width="1em" height="1em" viewBox="0 0 16 16" className="bi bi-chevron-down"
                                                fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                <path fillRule="evenodd"
                                                    d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" />
                                            </svg>
                                        </span>{/*//submenu-arrow*/}
                                    </a>

                                    <div id="submenu-4" className="collapse submenu submenu-4" data-bs-parent="#menu-accordion">
                                        <ul className="submenu-list list-unstyled">
                                            <li className="submenu-item"><Link to={myroutes.users_index} className={url === myroutes.users_index ? 'submenu-link active' : 'submenu-link'}>Utilisateurs</Link></li>
                                            <li className="submenu-item"><Link to={myroutes.roles_index} className={url === myroutes.roles_index ? 'submenu-link active' : 'submenu-link'} >Rôles Utilisateurs</Link></li>
                                            <li className="submenu-item"><Link to={myroutes.statuts_index} className={url === myroutes.statuts_index ? 'submenu-link active' : 'submenu-link'} >Statuts</Link></li>
                                            <li className="submenu-item"><Link to={myroutes.categories_index} className={url === myroutes.categories_index ? 'submenu-link active' : 'submenu-link'} >Catégories</Link></li>
                                            <li className="submenu-item"><Link to={myroutes.collections_index} className={url === myroutes.collections_index ? 'submenu-link active' : 'submenu-link'} >Collections</Link></li>
                                            <li className="submenu-item"><Link to={myroutes.rubriques_index} className={url === myroutes.rubriques_index ? 'submenu-link active' : 'submenu-link'} >Rubriques</Link></li>
                                            <li className="submenu-item"><Link to={myroutes.frequenceparutions_index} className={url === myroutes.frequenceparutions_index ? 'submenu-link active' : 'submenu-link'} >Fréquence des parutions</Link></li>
                                            <li className="submenu-item"><Link to={myroutes.periodicites_index} className={url === myroutes.periodicites_index ? 'submenu-link active' : 'submenu-link'} >Périodicités</Link></li>
                                            <li className="submenu-item"><Link to={myroutes.types_index} className={url === myroutes.types_index ? 'submenu-link active' : 'submenu-link'} >Types</Link></li>
                                            <li className="submenu-item"><a className="submenu-link" href="#" onClick={() => activeStorage()}>Active Storage</a></li>
                                            <li className="submenu-item"><a className="submenu-link" href="#" onClick={() => clearCache()}>Vider le Cache</a></li>
                                        </ul>
                                    </div>
                                </li>
                                </React.Fragment>}

                        </ul>{/*//app-menu*/}
                    </nav>{/*//app-nav*/}

                    <div className="app-sidepanel-footer">
                        <nav className="app-nav app-nav-footer">
                            <ul className="app-menu footer-menu list-unstyled">
                                <li className="nav-item">
                                    {/* */}
                                    <a className="nav-link" onClick={() => handleLogout()} href="#">
                                        <span className="nav-icon">
                                            <svg width="1em" height="1em" viewBox="0 0 16 16" className="bi bi-gear"
                                                fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                <path fillRule="evenodd"
                                                    d="M8.837 1.626c-.246-.835-1.428-.835-1.674 0l-.094.319A1.873 1.873 0 0 1 4.377 3.06l-.292-.16c-.764-.415-1.6.42-1.184 1.185l.159.292a1.873 1.873 0 0 1-1.115 2.692l-.319.094c-.835.246-.835 1.428 0 1.674l.319.094a1.873 1.873 0 0 1 1.115 2.693l-.16.291c-.415.764.42 1.6 1.185 1.184l.292-.159a1.873 1.873 0 0 1 2.692 1.116l.094.318c.246.835 1.428.835 1.674 0l.094-.319a1.873 1.873 0 0 1 2.693-1.115l.291.16c.764.415 1.6-.42 1.184-1.185l-.159-.291a1.873 1.873 0 0 1 1.116-2.693l.318-.094c.835-.246.835-1.428 0-1.674l-.319-.094a1.873 1.873 0 0 1-1.115-2.692l.16-.292c.415-.764-.42-1.6-1.185-1.184l-.291.159A1.873 1.873 0 0 1 8.93 1.945l-.094-.319zm-2.633-.283c.527-1.79 3.065-1.79 3.592 0l.094.319a.873.873 0 0 0 1.255.52l.292-.16c1.64-.892 3.434.901 2.54 2.541l-.159.292a.873.873 0 0 0 .52 1.255l.319.094c1.79.527 1.79 3.065 0 3.592l-.319.094a.873.873 0 0 0-.52 1.255l.16.292c.893 1.64-.902 3.434-2.541 2.54l-.292-.159a.873.873 0 0 0-1.255.52l-.094.319c-.527 1.79-3.065 1.79-3.592 0l-.094-.319a.873.873 0 0 0-1.255-.52l-.292.16c-1.64.893-3.433-.902-2.54-2.541l.159-.292a.873.873 0 0 0-.52-1.255l-.319-.094c-1.79-.527-1.79-3.065 0-3.592l.319-.094a.873.873 0 0 0 .52-1.255l-.16-.292c-.892-1.64.902-3.433 2.541-2.54l.292.159a.873.873 0 0 0 1.255-.52l.094-.319z" />
                                                <path fillRule="evenodd"
                                                    d="M8 5.754a2.246 2.246 0 1 0 0 4.492 2.246 2.246 0 0 0 0-4.492zM4.754 8a3.246 3.246 0 1 1 6.492 0 3.246 3.246 0 0 1-6.492 0z" />
                                            </svg>
                                        </span>
                                        <span className="nav-link-text">Se deconnecter</span>
                                    </a>{/*//nav-link*/}
                                </li>{/*//nav-item*/}

                            </ul>{/*//footer-menu*/}
                        </nav>
                    </div>{/*//app-sidepanel-footer*/}

                </div>{/*//sidepanel-inner*/}
            </div>{/*//app-sidepanel*/}
        </React.Fragment>
    )
}